// Two small overlay primitives, each a single reused DOM node:
//  - the Quick Add action sheet (small, bottom-anchored list of actions)
//  - a generic form sheet/modal (site picker, Add Expense, Add Income)
//
// They are separate elements on purpose: Issue A requires the Quick Add sheet to
// close immediately the moment an action is chosen, independent of whatever opens
// next. Reusing one shared overlay for both would blur that boundary.

let quickAddEl = null;
let formSheetEl = null;

export function mountOverlays(root) {
  quickAddEl = document.createElement('div');
  quickAddEl.className = 'quickAddSheet';
  quickAddEl.innerHTML = `
    <button type="button" data-action="expense">− Add Expense</button>
    <button type="button" data-action="income">+ Add Income</button>
    <button type="button" data-action="material">▣ Add Material Purchase</button>
    <button type="button" data-action="labour">♙ Add Labour Payment</button>
    <button type="button" data-action="upload">☁ Upload Statement</button>
    <button type="button" class="quickAddCancel" data-action="cancel">Cancel</button>
  `;
  root.appendChild(quickAddEl);

  const backdrop = document.createElement('div');
  backdrop.className = 'sheetBackdrop';
  root.appendChild(backdrop);

  formSheetEl = document.createElement('div');
  formSheetEl.className = 'formSheet';
  root.appendChild(formSheetEl);

  backdrop.addEventListener('click', () => {
    closeQuickAdd();
    closeFormSheet();
  });

  return { quickAddEl, formSheetEl, backdrop };
}

let quickAddHandler = null;

export function openQuickAdd(onAction) {
  quickAddHandler = onAction;
  document.querySelector('.sheetBackdrop')?.classList.add('show');
  quickAddEl.classList.add('open');
}

export function closeQuickAdd() {
  quickAddEl.classList.remove('open');
  if (!formSheetEl.classList.contains('open')) {
    document.querySelector('.sheetBackdrop')?.classList.remove('show');
  }
}

// Wire the quick-add sheet's own click handling once, at mount time -- this is
// what makes "close immediately on selection" actually synchronous rather than
// dependent on whatever the caller does next.
export function wireQuickAdd() {
  quickAddEl.addEventListener('click', (e) => {
    const btn = e.target.closest('button[data-action]');
    if (!btn) return;
    const action = btn.dataset.action;
    closeQuickAdd(); // closes immediately, before the chosen form (if any) opens
    if (action !== 'cancel' && quickAddHandler) quickAddHandler(action);
  });
}

export function openFormSheet(titleText, bodyEl) {
  formSheetEl.innerHTML = '';
  const head = document.createElement('div');
  head.className = 'formSheetHead';
  head.innerHTML = `<h2>${titleText}</h2><button type="button" class="closeFormSheet" aria-label="Close">×</button>`;
  head.querySelector('.closeFormSheet').addEventListener('click', closeFormSheet);
  formSheetEl.appendChild(head);
  formSheetEl.appendChild(bodyEl);

  document.querySelector('.sheetBackdrop')?.classList.add('show');
  formSheetEl.classList.add('open');
}

export function closeFormSheet() {
  formSheetEl.classList.remove('open');
  if (!quickAddEl.classList.contains('open')) {
    document.querySelector('.sheetBackdrop')?.classList.remove('show');
  }
}
